import React from 'react';
import {
  About,
  Mission,
  Members,
  Trainings,
  Partners,
  Contacts,
} from "./";
import UnifiedProjectsPage from './UnifiedProjectsPage';
import TrainingListGrouped from './TrainingListGrouped';
import AcademicCouncil from './AcademicCouncil';

const HomePage = () => {
  return (
    <>
      <About />
      <Mission />
      <Members />
      <UnifiedProjectsPage />
      <TrainingListGrouped />
      <Trainings />
      <AcademicCouncil />
      <Partners />
      <Contacts />
    </>
  );
};

export default HomePage;
